import { IAddressModel } from './../customer-address/customer-address.models';
import { AdditionalFeeItemModel, ShoppingCartApiModel } from "states/shopping-cart/shopping-cart.models";

export interface OrderPayment {
  paymentMethod: PaymentMethod;
  billingAddress: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    street: string;
    countryCode: string;
    countryName: string;
    stateCode: string;
    stateName: string;
    districtName: string;
    provinceName: string;
    postalCode: string;
  };
}
export enum PaymentMethod {
  Cod,
  Card,
  Cash,
  Transfer,
}
export interface OrderShippingModel {
  id: string;
  shippingType: ShippingTypeEnum;
  requestedPickupTime?: Date;
}

export interface IOrderItem {
  price: number;
  quantity: number;
  product: IProduct;
  modifiers: IOrderItem[];
}
export interface IProduct {
  id: number;
  images: string[];
  name: string;
  price: number;
  skuCode: string;
}
export interface IAppliedCouponModel {
  couponCode: string;
  shoppingCart: ShoppingCartApiModel;
  branchId: number;
}
export interface IPlaceOrderModel {
  branchId: number;
  totalAmount: number;
  coupon: OrderCouponModel;
  cartPromotions: ICartPromotionOrderModel[];
  tipAmount: number;
  requestedPickupTime?: Date;
  shippingAddressId?: number;
  shippingType: ShippingTypeEnum;
  orderItems: ICreatedOrderItemModel[];
}

export interface IPlaceOrderGuestModel {
  branchId: number;
  totalAmount: number;
  coupon: OrderCouponModel;
  cartPromotions: ICartPromotionOrderModel[];
  tipAmount: number;
  requestedPickupTime?: Date;
  shippingType: ShippingTypeEnum;
  orderItems: ICreatedOrderItemModel[];
  shippingAddress: IOrderShippingAddressModel;
  customerEmail?: string;
}
export interface IOrderShippingAddressModel{
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  postalCode?: string;
}
export interface ICartPromotionOrderModel {
  code: string;
  gifts: ICartPromotionOrderItemModel[];
}
export interface ICartPromotionOrderItemModel {
  id: number;
  quantity: number;
}
export interface OrderCouponModel {
  code: string;
  gifts: OrderCouponGiftModel[];
}
export interface OrderCouponGiftModel {
  id: number;
  quantity: number;
}
export interface ICreatedOrderItemModel {
  productId: number;
  price: number;
  quantity: number;
  modifiers: ICreatedOrderItemModel[];
}
export enum ShippingTypeEnum {
  Delivery,
  Pickup,
}
export interface IAvailableDateModel {
  day: string;
  times: IAvailableTimeModel[];
}
export interface IAvailableTimeModel {
  time: Date;
  displayText: string;
}

export interface IConfirmCheckoutModel {
  orderId: string;
  paymentGatewayCode: string;
  billingAddressId: number;
  requestedPickupTime?: Date;
  cardInfo: ICardInfoModel;
}
export interface IConfirmCheckoutGuestModel {
  orderId: string;
  paymentGatewayCode: string;
  billingAddress: IConfirmCheckoutBillingAddressGuestModel;
  cardInfo: ICardInfoModel;
}
export interface IConfirmCheckoutBillingAddressGuestModel{
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  postalCode?: string;
}
export interface ICardInfoModel {
  cardNumber: string;
  cvv: string;
  expiredMonth: string;
  expiredYear: string;
}

export interface IConfirmCheckoutResponseModel {
  branch: {
    id: number;
    name: string;
    ianaTimeZone: string;
  };
  id: string;
  firstName: string;
  lastName: string;
  customerName: string;
  orderNumber: string;
  totalAmount: number;
  shippingFee: number;
  tip: number;
  subTotal: number;
  discountAmount: number;
  taxes: number;
  additionalTaxes: AdditionalFeeItemModel[],
  nonCashAdjFee: number;
  couponCode: string;
  phoneNumber: string;
  email: string;
  note: string;
  customerId: number;
  creationTime: Date;
  orderItems: IOrderItem[];
  orderPayments: OrderPayment[];
  orderShippings: OrderShippingModel[];
  paymentDone: boolean;
}

export interface OrderState {
  confirmCheckoutSuccessModel?: IConfirmCheckoutResponseModel;
}
